import { streetApi } from "src/config/axios";
import customError from "./customError";

const eventDelete = async (
    eventId: number,
    deleteEventAtom: (event_id: number) => void
) => {
    return streetApi
        .delete(`/events/${eventId}`)
        .then(() => {
            deleteEventAtom(eventId);
        })
        .catch((error) => {
            const errorMessage = (error.response?.data as { message: string })
                ?.message;
            throw customError(errorMessage);
        });
};

export default eventDelete;
